import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { Catalog } from "../../models/product.model";
import { CatalogService } from "../../services/catalog.service";

@Component({
  selector: "ngx-dialog-link-catalog",
  templateUrl: "dialog-link-catalog.component.html",
  styleUrls: ["dialog-link-catalog.component.scss"],
})
export class DialogLinkCatalogComponent implements OnInit {
  @Input() header: string;
  @Input() mode?: string;
  @Input() shopId?: string;
  @Input() linkCatalogId: string;
  @Input() catalogs?: Catalog[];

  loading = false;
  submitted = false;
  strSearch = "";
  displays?: Catalog[];

  constructor(
    protected ref: NbDialogRef<DialogLinkCatalogComponent>,
    private fb: FormBuilder,
    private catalogService: CatalogService
  ) {}

  ngOnInit() {
    this.displays = [...this.catalogs];
  }

  cancel() {
    this.ref.close();
  }

  //Create
  create() {
    let cat = new Catalog();
    cat.title = this.strSearch.trim();
    cat.mode = this.mode;
    if (cat.title.length > 0) {
      this.loading = true;
      this.submitted = true;

      this.catalogService
        .create(cat)
        .then((data) => {
          this.catalogs.push(data);

          this.selected(JSON.parse(JSON.stringify(data)));
        })
        .catch((err) => {
          this.loading = false;
          this.submitted = false;
        });
    }
  }

  selected(item) {
    this.submitted = true;
    this.ref.close(item);
  }

  removeLink() {
    this.submitted = true;
    const value = {
      id: "",
    };
    this.ref.close(value);
  }
}
